import * as React from 'react';
// @ts-ignore
import { default as Form } from 'components/connectedForm';
import { BasicHeader } from '../../actions/BasicHeader';
import { PrimaryButton, SecondaryButton } from '../connectedForm/Button';
import { CSSProperties } from 'react';

export type FixedHeaderFooterSectionPropsType = {
  onClose?: () => void;
  title?: string;
  onConfirm?: () => void;
  children?: React.ReactNode;
  style?: CSSProperties;
};

export const TEXT_AREA_STYLES: React.CSSProperties = { minHeight: '200px', maxHeight: '200px', overflow: 'auto' };

const BODY_CONTAINER_STYLES: React.CSSProperties = {
  flex: 1,
  padding: '1em',
  overflowY: 'auto',
};

const FORM_ROW_CONTAINER_STYLES: React.CSSProperties = {
  flex: 1,
  overflow: 'auto',
};

const FORM_FOOTER_STYLES: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '1em',
  borderTop: '1px solid #ddd',
  background: '#fff',
  position: 'sticky',
  bottom: 0,
  zIndex: 10,
};

const WRAPPER_STYLES: React.CSSProperties = {
  maxHeight: '80vh',
  width: '800px',
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
};

const HEADER_CONTAINER_STYLES: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  background: '#fff',
  zIndex: 10,
  borderBottom: '1px solid #ddd',
};

export const FixedHeaderFooterSection = ({
  onClose,
  children,
  title,
  onConfirm,
  style = {},
}: FixedHeaderFooterSectionPropsType) => {
  return (
    <div style={{ ...WRAPPER_STYLES, ...style }}>
      <div style={HEADER_CONTAINER_STYLES}>
        <BasicHeader>{title}</BasicHeader>
      </div>
      <div style={BODY_CONTAINER_STYLES}>
        <Form.Form>
          <Form.Row>
            <div style={FORM_ROW_CONTAINER_STYLES}>{children}</div>
          </Form.Row>
        </Form.Form>
      </div>
      <div style={FORM_FOOTER_STYLES}>
        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
        {onConfirm && <PrimaryButton onClick={onConfirm}>Submit</PrimaryButton>}
      </div>
    </div>
  );
};
